(() => {
  const make = (tag, cls) => Object.assign(document.createElement(tag), {className: cls});
  function setup() {
    document.querySelectorAll('form[data-product-handle]').forEach(form => {
      const config = document.getElementById('reed-product-options-config');
      if (!config || form.dataset.productHandle !== JSON.parse(config.textContent).handle || form.dataset.reedScentDesign) return;
      const scent = form.querySelector('select[name="options[Scent]"]');
      const box = form.querySelector('scent-option-description');
      const heading = box?.querySelector('.product-form__option-label-wrapper');
      const track = box?.querySelector('.product-form__option-swatch-series-list');
      if (!scent || !heading || !track) return;
      form.dataset.reedScentDesign = 'true';
      form.classList.add('reed-scent-design');
      const series = make('span', 'reed-series');
      const count = make('span', 'reed-count');
      heading.append(series, count);
      const progress = make('div', 'reed-progress');
      const thumb = make('span', 'reed-progress__thumb');
      progress.setAttribute('aria-hidden', 'true');
      progress.hidden = true;
      progress.append(thumb);
      box.append(progress);
      const swatches = [...box.querySelectorAll('[data-scent-description-value]')];
      swatches.forEach(button => {
        button.title = button.getAttribute('aria-label');
        button.addEventListener('click', () => {
          if (button.disabled || scent.value === button.dataset.optionValue) return;
          scent.value = button.dataset.optionValue;
          scent.dispatchEvent(new Event('change', {bubbles:true}));
        });
      });
      function scrollProgress() {
        const row = track.closest('.product-form__scent-selector-row');
        const availableWidth = row?.clientWidth || track.clientWidth;
        const overflowing = availableWidth > 0 && track.scrollWidth > availableWidth + 1;
        box.dataset.scentOverflow = String(overflowing);
        progress.hidden = !overflowing;
        const width = Math.max(track.scrollWidth, 1);
        thumb.style.width = `${Math.min(100, track.clientWidth / width * 100)}%`;
        thumb.style.left = `${track.scrollLeft / width * 100}%`;
      }
      let previous = '';
      function update() {
        const selected = swatches.find(button => button.dataset.optionValue === scent.value);
        const seriesText = selected?.dataset.scentSeriesValue ? '· ' + selected.dataset.scentSeriesValue : '';
        const countText = `${swatches.indexOf(selected) + 1} / ${swatches.length}`;
        if (series.textContent !== seriesText) series.textContent = seriesText;
        if (count.textContent !== countText) count.textContent = countText;
        swatches.forEach(button => button.setAttribute('aria-pressed', String(button === selected)));
        if (selected && previous !== scent.value) {
          previous = scent.value;
          const b = selected.getBoundingClientRect(), t = track.getBoundingClientRect();
          track.scrollTo({left: track.scrollLeft + b.left - t.left - t.width / 2 + b.width / 2, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
        }
        scrollProgress();
      }
      track.addEventListener('scroll', scrollProgress, {passive: true});
      const resize = new ResizeObserver(scrollProgress);
      resize.observe(track);
      track.querySelectorAll('.product-form__option-swatches-wrapper').forEach(group => resize.observe(group));
      form.addEventListener('change', () => requestAnimationFrame(update));
      new MutationObserver(update).observe(heading.querySelector('[data-option-selected]'), {childList: true, characterData: true, subtree: true});
      update();
    });
  }
  setup();
  document.addEventListener('shopify:section:load', setup);
})();
